import { gql } from "@apollo/client";

export const MUTATION_UPDATE_USER_TO_PROCESS_HISTORY_BY_ID = gql`
  mutation MUTATION_UPDATE_USER_TO_PROCESS_HISTORY_BY_ID(
    $userToProcessHistoryId: uuid!, 
    $updates: userToProcessHistory_set_input
  ) {
    update_userToProcessHistory_by_pk(pk_columns: {id: $userToProcessHistoryId}, _set: $updates) {
      created_at
      customFormFieldChanges
      descript
      doctorId
      id
      isChecked
      latestCustomFormId
      processId
      stageId
      date
    }
  }
`

export const MUTATION_INSERT_USER_TO_PROCESS_HISTORY_GENERAL_NOTE = gql`
  mutation MUTATION_INSERT_USER_TO_PROCESS_HISTORY_GENERAL_NOTE(
    $stageId: String,
    $processId: Int, 
    $userToProcessId: uuid, 
    $doctorId: uuid, 
    $descript: String
  ) {
    insert_userToProcessHistory(objects: {descript: $descript, doctorId: $doctorId, isGeneralNote: true, processId: $processId, userToProcessId: $userToProcessId, stageId: $stageId, isChecked: true}) {
      returning {
        created_at
        date
        descript
        doctorId
        id
        isGeneralNote
        userToProcessId
        processId
      }
    }
  }
`

export const MUTATION_UPDATE_USER_TO_PROCESS_HISTORY_GENERAL_NOTE = gql`
  mutation MUTATION_UPDATE_USER_TO_PROCESS_HISTORY_GENERAL_NOTE(
    $userToProcessHistoryId: uuid!, 
    $doctorId: uuid, 
    $descript: String
  ) {
    update_userToProcessHistory(where: {id: {_eq: $userToProcessHistoryId}}, _set: {doctorId: $doctorId, descript: $descript}) {
      returning {
        created_at
        date
        descript
        doctorId
        id
        isChecked
        isGeneralNote
        processId
        latestCustomFormId
        stageId
        userToProcessId
      }
    }
  }
`